import React, { useMemo, useState, useCallback } from "react";
import {
  useGetTableData,
  useDeleteData,
  useCreateData,
  usePutData,
} from "../../Plan/tableHooks";
import { useQueryClient } from "@tanstack/react-query";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { localizationTextObjectForInformation } from "../../../../utils/constants";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import Pen01 from "../../Nucleo-Icons/pen-01";
import Trash from "../../Nucleo-Icons/trash";
import Box3d50 from "../../Nucleo-Icons/box-3d-50";
import CreateItemModal from "./CreateItemModal";
import SearchIcon from "@mui/icons-material/Search";
import { useParams } from "react-router-dom";
import { AddButton } from "../../../common/Buttons";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import goToHelpLink from "../../../../utils/goToHelpLink";
import EditRowDialog from "./EditRowDialog";

function Item({
  setClickedItemId,
  clickedItemId,
  setClickedProcId,
  orderData,
  onShowConfirmation,
  openSnackbar,
  itemData,
}) {
  const queryClient = useQueryClient();
  const { group_code, project_code } = useParams();
  const [updateStatus, setUpdateStatus] = useState(false);
  const [itemSearchText, setItemSearchText] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const updateItem = usePutData(null, "/api/item/updateItem", openSnackbar);
  const deleteItem = useDeleteData(null, "/api/item/deleteItem", openSnackbar);
  const createItem = useCreateData(null, "/api/item/createItem", openSnackbar);
  const tableData = useMemo(() => {
    if (!itemData) return [];
    if (!itemSearchText.trim()) return itemData;
    const lowerCaseSearchText = itemSearchText.toLowerCase();
    return itemData.filter((item) => {
      return (
        item.item_name?.toLowerCase().includes(lowerCaseSearchText) ||
        String(item.item_id).toLowerCase().includes(lowerCaseSearchText) ||
        String(item.proc_time / 60)
          .toLowerCase()
          .includes(lowerCaseSearchText)
      );
    });
  }, [itemData, itemSearchText]);
  const columns = [
    {
      accessorKey: "item_id",
      header: "Item ID",
      size: 80,
      muiTableHeadCellProps: { sx: { display: "none" } },
      muiTableBodyCellProps: { sx: { display: "none" } },
      muiTableFooterCellProps: { sx: { display: "none" } },
      enableEditing: false,
    },
    {
      accessorKey: "item_name",
      header: "고객사 품번",
      size: 110,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "material_grouping",
      header: "사내 품명",
      size: 110,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "car_type",
      header: "차종",
      size: 110,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "spec",
      header: "규격",
      size: 110,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "sub_code",
      header: "사내품번",
      size: 110,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    // {
    //   accessorKey: "proc_qty",
    //   header: "총 공정 수",
    //   size: 80,
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    //   muiTableFooterCellProps: { align: "center" },
    //   enableEditing: false,
    // },
    // {
    //   accessorKey: "proc_time",
    //   header: "공정 시간 합계",
    //   size: 80,
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    //   muiTableFooterCellProps: { align: "center" },
    //   Cell: ({ row }) => {
    //     const minutes = row.original.proc_time / 60;
    //     const isInteger = minutes % 1 === 0;
    //     return `${isInteger ? minutes : minutes.toFixed(1)}분`;
    //   },
    //   enableEditing: false,
    // },
    {
      accessorKey: "safety_stock",
      header: "안전재고",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "gantt_color",
      header: "색상",
      size: 50,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: false,
      Cell: ({ row }) => {
        const color = row.original.gantt_color ?? "#ff8787";
        return (
          <div
            style={{
              width: 20,
              height: 20,
              background: color,
              border: "none",
              margin: "0 auto",
            }}
            title={color}
          />
        );
      },
    },
  ];
  const onItemSearchTextChange = useCallback((event) => {
    setItemSearchText(event.target.value);
  }, []);
  // const handleDeleteItem = async (row) => {
  //   const matchedOrder = orderData.filter(
  //     (c) => c.item_id === row.original.item_id
  //   );
  //   console.log("matchedOrder : ", matchedOrder);
  //   if (
  //     window.confirm(
  //       "아이템을 삭제하시겠습니까? 하위 공정과 장비 정보가 모두 삭제됩니다."
  //     )
  //   ) {
  //     try {
  //       await deleteItem.mutateAsync({
  //         itemId: row.original.item_id,
  //       });
  //       table.setCreatingRow(null);
  //     } catch (error) {
  //       console.error("Error updating process:", error);
  //     }
  //   }
  // };
  const handleDeleteItem = async (row) => {
    const matchedOrder = orderData
      .filter((c) => c.item_id === row.original.item_id)
      .map((c) => c.order_name);
    const mainText = matchedOrder.length
      ? `${matchedOrder} 생산계획이 삭제됩니다.`
      : "아이템을 삭제합니다.";
    onShowConfirmation({
      title: "아이템 삭제",
      mainText: mainText,
      subText:
        "또한, 하위 공정과 장비 정보가 모두 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 삭제를 진행하시겠습니까?",
      onConfirm: async () => {
        try {
          await deleteItem.mutateAsync({
            itemId: row.original.item_id,
            group_code,
            project_code,
          });
          table.setCreatingRow(null);
          queryClient.invalidateQueries([updateStatus]);
        } catch (error) {
          console.error("Error deleting item:", error);
        }
      },
    });
  };
  const handleEditItem = async ({ values, table }) => {
    if (values.item_name?.trim()) {
      try {
        const updateData = [
          values.item_id,
          values.item_name,
          values.material_grouping,
          values.safety_stock,
          values.gantt_color,
          values.car_type || "",
          values.spec || "",
          values.sub_code || "",
          group_code,
          project_code,
        ];
        if (values.item_name.length > 15) {
          openSnackbar("제품명은 15자 이내로 입력해 주세요.", "warning");
          return;
        }
        await updateItem.mutateAsync(updateData);
        table.setEditingRow(null);
      } catch (error) {
        console.error("Error updating process:", error);
      }
    } else {
      openSnackbar("제품명을 입력해 주세요.", "info");
    }
  };
  const handleAddItem = async ({ values, table }) => {
    if (values.item_name?.trim()) {
      try {
        const createData = [
          values.item_name.trim(),
          values.material_grouping,
          values.safety_stock,
          values.gantt_color,
          values.sub_code || "",
          values.spec || "",
          values.car_type || "",
          group_code,
          project_code,
          1,
        ];
        if (values.item_name.length > 15) {
          openSnackbar("Item 이름은 15자 이내로 입력해 주세요.", "warning");
          return;
        }
        await createItem.mutateAsync(createData);
        table.setCreatingRow(null);
      } catch (error) {
        console.error("Error updating process:", error);
      }
    } else {
      openSnackbar("Item 이름을 입력해 주세요.", "info");
    }
  };
  const table = useMaterialReactTable({
    data: tableData ?? [],
    columns,
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
    autoResetPageIndex: false,
    enableColumnFilters: false,
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableSorting: false,
    enableStickyHeader: true,
    enableColumnActions: false,
    enableEditing: true,
    createDisplayMode: "modal",
    editDisplayMode: "modal",
    onCreatingRowSave: handleAddItem,
    localization: localizationTextObjectForInformation,
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
        background: () => {
          return clickedItemId === Number(row.original.item_id)
            ? "#dee2e6 !important"
            : "#F8F7FA !important";
        },
      },
      onClick: (e) => {
        setClickedItemId(row.original.item_id);
        setClickedProcId(0);
      },
    }),
    muiTablePaperProps: {
      sx: {
        width: "100%",
        height: "100%",
        background: "#fff",
        "& .css-qc99f7": {
          position: "absolute !important",
          bottom: "30px",
          borderBottom: "1px solid #d6d8df",
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        color: "black",
        fontWeight: "500",
        fontSize: "14px",
      },
    },
    muiTableFooterCellProps: {
      sx: {
        position: "absolute !important",
        bottom: 0,
      },
    },
    onEditingRowSave: handleEditItem,
    muiTableHeadProps: {
      sx: {
        "& tr": {
          fontWeight: "700",
          borderRadius: "14px",
          background: "#f3f6f9",
          color: "#464e5f",
          "& th": {
            fontWeight: "500 !important",
            color: "black",
            padding: "0.5rem",
            fontSize: "15px",
          },
        },
      },
    },
    paginationDisplayMode: "pages",
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          height: "40px",
          width: "150px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          fontSize: "22px",
          background: "#F8F7FA",
          fontWeight: "700",
          gap: "1rem",
          paddingLeft: "0.53rem",
        }}
        // color="secondary"
        // onClick={() => {
        //   alert("Create New Account");
        // }}
        // variant="contained"
      >
        <Box3d50 />
        완제품{" "}
        <Tooltip
          title="이동"
          sx={{ cursor: "pointer" }}
          onClick={() =>
            goToHelpLink(
              "http://esehelp.cafe24.com/scheduler#h-8-1-%EC%95%84%EC%9D%B4%ED%85%9C-%EC%98%81%EC%97%AD"
            )
          }
        >
          <HelpOutlineIcon />
        </Tooltip>
      </Box>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <TextField
          placeholder="검색어를 입력하세요"
          variant="outlined"
          sx={{
            width: "70%",
            marginBottom: "0px",
          }}
          size="small"
          value={itemSearchText}
          onChange={onItemSearchTextChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <AddButton
          onClick={() => {
            table.setCreatingRow(true);
          }}
        />
      </div>
    ),
    positionActionsColumn: "last",
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", width: "50px" }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <Pen01 />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton
            onClick={async () => {
              await handleDeleteItem(row);
              queryClient.invalidateQueries([updateStatus]);
            }}
            color="error"
          >
            <Trash />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderCreateRowDialogContent: ({ table }) => (
      <CreateItemModal table={table} handleAddItem={handleAddItem} type={1} />
    ),
    renderEditRowDialogContent: ({ internalEditComponents, row, table }) => (
      <>
        <EditRowDialog
          table={table}
          row={row}
          initialData={row.original}
          handleUpdateOrder={handleEditItem}
        />
      </>
    ),
    muiBottomToolbarProps: {
      sx: {
        position: "absolute !important",
        bottom: "42px",
        left: "50%",
        width: "inherit",
        transform: "translate(-50%, -50%)",
      },
    },
  });
  return (
    <MaterialReactTable
      muiTableBodyProps={{
        sx: { overflow: "visible" },
      }}
      table={table}
    />
  );
}

export default Item;
